import React from "react";

import { Heading, Link, List, ListItem } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

import { ShopNavigationGroups } from "@header/types";

import { ItemPath, trackMenuClick } from "../../utilities/analytics";
import { MenuLink } from "../MenuLink";

type MenuCategoryProps = {
  navItem: ShopNavigationGroups;
  itemPathCategory: ItemPath[];
};

const CategoryColumn = styled(ListItem)`
  break-inside: avoid;
`;

const CategoryHeadingLink = styled(Link)`
  transition: none;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

export const MenuCategory = ({
  navItem,
  itemPathCategory,
}: MenuCategoryProps) => {
  return (
    <CategoryColumn mb="16px">
      <Heading.h5
        borderBottom="solid 1px"
        borderBottomColor="ui.borderColor"
        mt="0"
        mb="10px"
        lineHeight="1.2rem"
        pb="4px"
      >
        <CategoryHeadingLink
          tabIndex={-1}
          id={`head-link-${navItem.id}`}
          href={navItem.url}
          color="typography.text"
          onClick={() =>
            trackMenuClick({
              name: navItem.name,
              url: `${location.origin}${navItem.url}`,
              item_path: itemPathCategory,
            })
          }
        >
          {navItem.name}
        </CategoryHeadingLink>
      </Heading.h5>
      {navItem.shopNavigationItems.length > 0 && (
        <List m="0">
          {navItem.shopNavigationItems.map((shopItem, index) => (
            <MenuLink
              key={shopItem.id}
              navItem={shopItem}
              itemPathLink={[
                ...itemPathCategory,
                { name: shopItem.name, id: shopItem.id, position: index + 1 },
              ]}
            />
          ))}
        </List>
      )}
    </CategoryColumn>
  );
};
